import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CategoryCard from "./CategoryCard";
import { useProducts } from "../../../contexts/Products";
import { useServices } from "../../../contexts/Services";
import Tabs from "../../../components/controls/Tabs";
import Button from "../../../components/controls/Button";

const CategorySelection = ({
  nextStep,
  updateEventData,
  eventData,
  goToPreviousStep,
}) => {
  const { t } = useTranslation();
  const [selectedProducts, setSelectedProducts] = useState(
    eventData?.selectedProducts || []
  );
  const [selectedServices, setSelectedServices] = useState(
    eventData?.selectedServices || []
  );
  const [activeTab, setActiveTab] = useState("products");

  const products = useProducts("products");
  const services = useServices("services");

  const tabs = [
    { key: "products", label: t("categorySelection.productsTab") },
    { key: "services", label: t("categorySelection.servicesTab") },
  ];

  const toggleId = (list, id) =>
    list.includes(id) ? list.filter((x) => x !== id) : [...list, id];

  const handleCategorySelect = (id, type) => {
    if (type === "products") {
      const next = toggleId(selectedProducts, id);
      setSelectedProducts(next);
      updateEventData({ selectedProducts: next });
      return;
    }

    const next = toggleId(selectedServices, id);
    setSelectedServices(next);
    updateEventData({ selectedServices: next });
  };

  return (
    <div className="w-full">
      <div className="w-full max-w-[90%] mx-auto bg-white shadow-lg p-6 rounded-lg text-primary">
        <div className="flex flex-col items-center">
          <h2 className="text-3xl font-extrabold mb-2">
            {t("categorySelection.title")}
          </h2>
          <p className="text-muted text-center mb-6 max-w-3xl">
            {t("categorySelection.description")}
          </p>
        </div>

        <Tabs
          tabs={tabs}
          activeIndex={activeTab === "products" ? 0 : 1}
          onChange={(i) => setActiveTab(i === 0 ? "products" : "services")}
        />

        <div className="p-4 flex flex-wrap gap-6 w-full border border-ananas rounded-b-lg rounded-r-lg">
          {(activeTab === "products" ? products : services).map((category) => (
            <div
              key={category.id}
              className="w-full sm:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)]"
            >
              <CategoryCard
                category={category}
                title={t(`${category.name}`)}
                description={category.description}
                isSelected={
                  activeTab === "products"
                    ? selectedProducts.includes(category.id)
                    : selectedServices.includes(category.id)
                }
                onSelect={() =>
                  handleCategorySelect(
                    category.id,
                    activeTab === "products" ? "products" : "services"
                  )
                }
              />
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap gap-4 justify-between w-full border-t pt-6">
          <div className="w-full sm:flex-1">
            <button
              type="button"
              onClick={goToPreviousStep}
              className="w-full px-4 h-12 bg-muted/20 text-primary rounded-full border border-gray-200 hover:bg-muted/30 transition"
            >
              {t("stepTwo.buttons.back")}
            </button>
          </div>

          <div className="w-full sm:flex-1">
            <Button
              as="button"
              type="button"
              onClick={nextStep}
              color="primary"
              size="lg"
              className="w-full"
            >
              {t("stepOne.nextButton")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategorySelection;
